export default __webpack_public_path__ + "static/media/katfetjisan.a0b41994.png";